import { Component, Input, OnInit } from '@angular/core';
import { ChispazoTicket } from '@app/@shared/models/chispazo.model';
import { GameTicket, GameType } from '@app/@shared/models/game.model';
import { GanaGatoTicket } from '@app/@shared/models/gana-gato.model';
import { Match, Quiniela } from '@app/@shared/models/match.model';
import { MelateTicket } from '@app/@shared/models/melate.model';
import { Touch } from '@app/@shared/models/quiniela.model';
import { SorteoTicket, SorteoType } from '@app/@shared/models/sorteo.model';
import { TrisTicket } from '@app/@shared/models/tris.model';
import { ChispazoService } from '@app/@shared/services/chispazo.service';
import { GanaGatoService } from '@app/@shared/services/gana-gato.service';
import { GeneralService } from '@app/@shared/services/general.service';
import { MelateService } from '@app/@shared/services/melate.service';
import { ProgolService } from '@app/@shared/services/progol.service';
import { ProtouchService } from '@app/@shared/services/protouch.service';
import { SorteoService } from '@app/@shared/services/sorteo.service';
import { TrackingService } from '@app/@shared/services/tracking.service';
import { TrisService } from '@app/@shared/services/tris.service';
import { CredentialsService } from '@app/auth/credentials.service';
import { ModalController } from '@ionic/angular';
import { GameLogoService } from '@app/@shared/services/game-logo.service';

@Component({
  selector: 'app-boards',
  templateUrl: './boards.component.html',
  styleUrl: './boards.component.scss',
})
export class BoardsComponent implements OnInit {
  @Input() trackingS!: TrackingService;
  @Input() option = 'favorite';
  @Input() isModal = true;
  @Input() isResume = false;
  @Input() tickets: GameTicket[] = [];
  @Input() gameType!: GameType;
  @Input() executeResponseRequests: any[] = [];
  @Input() executePayloadRequests: any[] = [];
  @Input() isPayment = false;
  @Input() quantity = 0;
  @Input() sorteoType?: SorteoType;
  @Input() sorteoS?: SorteoService;

  @Input() uid: string = '';
  @Input() hour: string = '';

  sorteoTickets: SorteoTicket[] = [];
  isRetro = false;
  isRevancha = false;
  isRevanchita = false;
  isMultiplier = false;
  @Input() isCoperacha = false;
  @Input() melateS?: MelateService;
  melateTickets: MelateTicket[] = [];

  @Input() chispazoS?: ChispazoService;
  chispazoTickets: ChispazoTicket[] = [];

  @Input() trisS?: TrisService;
  trisTickets: TrisTicket[] = [];

  @Input() ganaGatoS?: GanaGatoService;
  ganaGatoTickets: GanaGatoTicket[] = [];

  @Input() progolS?: ProgolService;
  progolTickets: Match[][] = [];
  isMediaSemana = false;

  @Input() protouchS?: ProtouchService;
  @Input() touches: Touch[] = [];
  protouchTickets: Match[][] = [];

  quinielaValues: string[][] = [];

  selected: boolean[] = [];
  letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  dates: Date[] = [];

  isLoading = true;
  digitsSign = [
    {
      nombreSorteo: 'superior',
      digitosBillete: 5,
      digitosTerminacion: 3,
    },
    {
      nombreSorteo: 'zodiaco-especial',
      digitosBillete: 4,
      digitosTerminacion: 2,
    },
    {
      nombreSorteo: 'especial',
      digitosBillete: 5,
      digitosTerminacion: 3,
    },
    {
      nombreSorteo: 'gran-especial',
      digitosBillete: 7,
      digitosTerminacion: 3,
    },
    {
      nombreSorteo: 'mayor',
      digitosBillete: 5,
      digitosTerminacion: 3,
    },
    {
      nombreSorteo: 'magno',
      digitosBillete: 5,
      digitosTerminacion: 3,
    },
    {
      nombreSorteo: 'zodiaco',
      digitosBillete: 4,
      digitosTerminacion: 2,
    },
    {
      nombreSorteo: 'gordito',
      digitosBillete: 5,
      digitosTerminacion: 3,
    },
  ];
  logoTris = '/assets/logos/tris.svg';
  logoMelate = '/assets/boards/melate.png';
  logoMelateRetro = '/assets/logos/melate-retro.svg';
  logoChispazo = '/assets/logos/chispazo.svg';
  logoProgol = '/assets/logos/progol.svg';
  logoProgolMedia = '/assets/logos/progol-media-semana.svg';
  logoProgolRevancha = '/assets/logos/progol-revancha.svg';
  logoProtouch = '/assets/logos/protouch.svg';
  logoGanaGato = '/assets/logos/gana-gato.svg';

  constructor(private modalCtrl: ModalController, private gameLogoS: GameLogoService) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.loadLogos();
    this.loadData();
  }

  private async loadLogos(): Promise<void> {
    await this.gameLogoS.ensureLoaded();
    this.logoTris = this.gameLogoS.getLogo('Tris', this.logoTris);
    this.logoMelate = this.gameLogoS.getLogo('Melate', this.logoMelate);
    this.logoMelateRetro = this.gameLogoS.getLogo('MelateRetro', this.logoMelateRetro);
    this.logoChispazo = this.gameLogoS.getLogo('Chispazo', this.logoChispazo);
    this.logoProgol = this.gameLogoS.getLogo('Progol', this.logoProgol);
    this.logoProgolMedia = this.gameLogoS.getLogo('ProgolMediaSemana', this.logoProgolMedia);
    this.logoProgolRevancha = this.gameLogoS.getLogo('Progol', this.logoProgolRevancha);
    this.logoProtouch = this.gameLogoS.getLogo('Protouch', this.logoProtouch);
    this.logoGanaGato = this.gameLogoS.getLogo('GanaGato', this.logoGanaGato);
  }

  async loadData() {
    try {
      this.isLoading = true;
      //.log('loadData', this.gameType);
      if (!this.tickets.length) return;
      if (this.option === 'favorite') {
        if (this.melateS) {
          this.melateTickets = await this.melateS.getFavorites(this.isRetro);
          this.melateTickets.forEach(() => {
            this.selected.push(true);
          });
        } else if (this.sorteoS && this.sorteoType) {
          const path = this.sorteoS.getPaths().find((p) => p.path === this.sorteoType)!;
          this.sorteoTickets = await this.sorteoS.getFavorites(path);
          this.sorteoTickets.forEach((v) => {
            this.selected.push(true);
          });
          // console.log('sorteoS: ', this.gameType);
        } else if (this.chispazoS) {
          const wager = await this.chispazoS.getWagerInfo();

          this.chispazoTickets = await this.chispazoS.getFavorite(wager!);
          this.chispazoTickets.forEach((v) => {
            this.selected.push(true);
          });
        } else if (this.trisS) {
          this.trisTickets = await this.trisS.getFavorite();
          this.trisTickets.forEach((v) => {
            this.selected.push(true);
          });
        } else if (this.ganaGatoS) {
          this.ganaGatoTickets = this.ganaGatoS.getFavorite();
          this.ganaGatoTickets.forEach((v) => {
            this.selected.push(true);
          });
          // console.log('ganaGatoS: ', this.gameType);
        }
      } else if (this.option === 'purchase' || this.option === 'resume') {
        if (this.gameType === 'melate') {
          this.melateTickets = this.tickets as MelateTicket[];
          this.isRetro = this.melateTickets.some((t) => t.price.amounts.length === 0);

          this.isRevanchita = !this.isRetro && this.melateTickets.some((t) => t.types.includes('Revanchita'));
          this.isRevancha =
            !this.isRetro && !this.isRevanchita && this.melateTickets.some((t) => t.types.includes('Revancha'));

          this.dates = this.melateTickets[0].dates;
        } else if (this.gameType === 'sorteo') {
          // const path = this.sorteoS.getPaths().find((p) => p.path === this.sorteoType)!;
          // this.sorteoTickets = this.sorteoS.getFavorites(path);
          // this.sorteoTickets.forEach((v) => {
          //   this.selected.push(true);
          // });
          this.sorteoTickets = this.tickets as SorteoTicket[];
          this.sorteoTickets.forEach((v) => {
            this.selected.push(true);
          });
          // console.log('sorteoTickets: ', this.gameType);
        } else if (this.gameType === 'chispazo') {
          this.chispazoTickets = this.tickets as ChispazoTicket[];
          // this.chispazoTickets.forEach((v) => {
          //   this.selected.push(true);
          // });
          this.dates = this.chispazoTickets[0].dates;
        } else if (this.gameType === 'tris') {
          this.trisTickets = this.tickets as TrisTicket[];
          // this.trisTickets.forEach((v) => {
          //   this.selected.push(true);
          // });
          this.dates = this.trisTickets[0].dates;
          this.isMultiplier = this.trisTickets.some((t) => t.multiplicadorAmount > 0);
        } else if (this.gameType === 'gana-gato') {
          this.ganaGatoTickets = this.tickets as GanaGatoTicket[];
          // this.ganaGatoTickets.forEach((v) => {
          //   this.selected.push(true);
          // });
          //console.log('ganaGatoS: ', this.gameType);
        } else if (this.gameType === 'progol') {
          this.isMediaSemana = (this.tickets as Match[][])[0].length === 9;

          if (this.isMediaSemana) {
            this.progolTickets = this.tickets as Match[][];
          } else {
            const tickets = this.tickets.slice(0, this.tickets.length / 2) as Match[][];
            const revTickets = this.tickets.slice(this.tickets.length / 2) as Match[][];

            tickets.forEach((t, i) => {
              this.progolTickets.push(t);
              this.progolTickets.push(revTickets[i]);
            });

            this.isRevancha = revTickets.length > 0;
          }
          this.quinielaValues = this.progolTickets.map((t) => {
            return t.map((m) => {
              const result: string[] = [];
              if (m.selected.includes('local')) result.push('L');
              if (m.selected.includes('draw')) result.push('E');
              if (m.selected.includes('visit')) result.push('V');
              return result.length === 3 ? 'T*' : result.join('');
            });
          });
        } else if (this.gameType === 'protouch') {
          this.protouchTickets = [...(this.tickets as Match[][])];

          // en dado caso que sea tickets antiguso mostras ST
          if (!this.touches) {
            this.touches = this.protouchTickets.map(() => 'st');
          }

          this.quinielaValues = this.protouchTickets.map((t, k) => {
            return [...t, null].map((m) => {
              //si es null es el tocuh inicial
              if (m === null) {
                // se agrega st solo para visualizar
                const touch = (this.touches[k] as string).toUpperCase();
                return touch === 'ST' ? touch : `${touch[0]}${+touch[1] + 1}`;
              }

              const result: string[] = [];
              if (m.selected.includes('local')) result.push('L');
              if (m.selected.includes('draw')) result.push('D');
              if (m.selected.includes('visit')) result.push('V');
              return result.length === 3 ? 'T*' : result.join('');
            });
          });
        }
      }
      if (
        this.isPayment &&
        this.gameType === 'tris' &&
        this.executePayloadRequests.length &&
        this.executeResponseRequests.length
      ) {
        const wagersPerDay = this.executePayloadRequests.length / this.dates.length;
        this.dates = this.dates.filter((d, i) => {
          const startIndex = i * wagersPerDay;
          const endIndex = (i + 1) * wagersPerDay;
          for (let j = startIndex; j < endIndex; j++) {
            if (this.executeResponseRequests[j] !== null && this.executeResponseRequests[j] !== undefined) {
              return true;
            }
          }
          return false;
        });
      } else if (this.isPayment && this.executePayloadRequests.length && this.executeResponseRequests.length) {
        const boletasPorDia =
          (this.executePayloadRequests.length / this.dates.length) * this.executeResponseRequests.length;

        this.dates = this.dates.filter((d, i) => i < boletasPorDia);
      }
      this.isLoading = false;
    } catch (error) {
      //console.log(error);
    }
  }

  close() {
    this.modalCtrl.dismiss();
  }

  deleteValue(i: number) {}

  goTo() {}

  reload(i: number) {}

  changeSelected(i: number) {
    this.selected[i] = !this.selected[i];
  }

  changeQuantity(n: number) {}

  // getZodiacName(icon: string) {
  //   const zodiacs = this.sorteoS?.zodiac.find((z) => z.icon === icon);

  //   return zodiacs?.name ?? '';
  // }
  getZodiacName(signo: number | null | undefined): { es: string; en: string } {
    if (signo === null || signo === undefined) {
      return { es: 'Desconocido', en: 'unknown' };
    }

    const zodiacSigns = [
      { es: 'Aries', en: 'aries' }, // 1
      { es: 'Tauro', en: 'taurus' }, // 2
      { es: 'Géminis', en: 'gemini' }, // 3
      { es: 'Cáncer', en: 'cancer' }, // 4
      { es: 'Leo', en: 'leo' }, // 5
      { es: 'Virgo', en: 'virgo' }, // 6
      { es: 'Libra', en: 'libra' }, // 7
      { es: 'Escorpión', en: 'scorpio' }, // 8 ← corregido
      { es: 'Sagitario', en: 'sagittarius' }, // 9
      { es: 'Capricornio', en: 'capricorn' }, // 10
      { es: 'Acuario', en: 'aquarius' }, // 11
      { es: 'Piscis', en: 'pisces' }, // 12
    ];

    if (signo >= 1 && signo <= 12) {
      return zodiacSigns[signo - 1];
    } else {
      return { es: 'Desconocido', en: 'unknown' };
    }
  }

  getDigits(numeroBillete: number | string, drawType: string): number[] {
    if (numeroBillete == null) return [];

    const numeroStr = numeroBillete.toString();

    // Buscamos la configuración del sorteo en digitsSign
    const configSorteo = this.digitsSign.find((sorteo) => sorteo.nombreSorteo === drawType);

    // Si no existe configuración, devolvemos el número sin cambios
    if (!configSorteo) {
      // console.warn(`No se encontró configuración para el sorteo: ${drawType}`);
      return numeroStr.split('').map(Number);
    }

    const digitosRequeridos = configSorteo.digitosBillete;

    // Agrega los ceros a la izquierda si es necesario
    const numeroFormateado = numeroStr.padStart(digitosRequeridos, '0');

    return numeroFormateado.split('').map(Number);
  }
  trackingTicketsConfirmed(ticket: GameTicket[], gameType: GameType) {
    let ticketDetail: any = {};
    let totalAmount = 0;

    if (gameType === 'tris') {
      ticketDetail = ticket.map((t: any) => ({
        name: t.price?.name,
        value: t.value,
      }));
      totalAmount = ticket.reduce((sum: any, t: any) => sum + (t.amount || 0), 0);
    } else if (gameType === 'chispazo') {
      ticketDetail = ticket.map((t: any) => ({
        value: t.value,
      }));
      totalAmount = ticket.reduce((sum: any, t: any) => sum + (t.amount || 0), 0);
    } else if (gameType === 'melate') {
      ticketDetail = ticket.map((t: any) => ({
        value: t.value,
        types: t.types,
      }));
      totalAmount = ticket.reduce((sum: any, t: any) => sum + (t.amount || 0), 0);
    } else if (gameType === 'gana-gato') {
      ticketDetail = ticket.map((t: any) => ({
        value: t.value,
      }));
      totalAmount = ticket.reduce((sum: any, t: any) => sum + (t.amount || 0), 0);
    } else if (gameType === 'progol') {
      ticketDetail = (ticket as Match[][]).map((ticketBoleta) => ticketBoleta.map(({ id, ...rest }) => rest));
      totalAmount = ticket.length;
    } else if (gameType === 'protouch') {
      ticketDetail = ticket.map((ticketBoleta: any) =>
        ticketBoleta.map(({ id, ...rest }: { id: any; [key: string]: any }) => rest)
      );
      totalAmount = ticket.length;
    }
    this.trackingS.trackEvent(
      'ticket_confirmed',
      {
        game_id: gameType,
        tickets_quantity: ticket.length,
        ticketDetail: ticketDetail,
        parcial_amount: totalAmount,
      },
      false,
      false
    );
  }
}
